import * as React from 'react';
import styled from '@emotion/styled';
import { MDXProvider } from '@mdx-js/react';

import ThemeProvider from './theme/themeProvider';
import mdxComponents from './mdxComponents';
import Sidebar from './sidebar';
import RightSidebar from './rightSidebar';
import config from '../../config.js';
import Header from './Header';

const Wrapper = styled('div')`
  display: flex;
  justify-content: space-between;
  background: ${({ theme }) => theme.colors.background};

  .sideBarUL {
    width: 270px;
    box-sizing: border-box;
    transition: width 300ms cubic-bezier(0.25, 0.67, 0.48, 1);
    padding: 30px 10px;
    padding-right: 0px;
    color: #2f3037;
    z-index: 0;
    overflow: auto;
    border-radius: 8px;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .sideBarUL li a {
    color: #2f3037;
  }

  .sideBarUL .item > a:hover {
    background: linear-gradient(121deg, #9bc9e541 -8.42%, #8b7ce154 100%);
    color: #2f3037 !important;
    border-radius: 8px;

    /* background: #F8F8F8 */
  }

  @media only screen and (max-width: 767px) {
    display: block;
  }
`;

const Content = styled('main')`
  display: flex;
  flex-grow: 1;
  margin: 0px 88px;
  padding-top: 1.5rem;
  background: ${({ theme }) => theme.colors.background};

  table tr {
    background: ${({ theme }) => theme.colors.background};
  }

  @media only screen and (max-width: 1023px) {
    padding-left: 0;
    margin: 0 10px;
    padding-top: 3rem;
  }
`;

const MaxWidth = styled('div')`
  @media only screen and (max-width: 50rem) {
    width: 100%;
    position: relative;
  }
`;

const LeftSideBarWidth = styled('div')`
  width: 288px;
`;

const RightSideBarWidth = styled('div')`
  width: 224px;
`;

const Layout = ({ children, location }) => (
  <ThemeProvider location={location}>
    <MDXProvider components={mdxComponents}>
      <Wrapper>
        <LeftSideBarWidth className={'hiddenMobile'}>
          <Sidebar location={location} />
        </LeftSideBarWidth>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Header />
          <div className="mainContent">
            <Content>
              <MaxWidth>{children}</MaxWidth>
            </Content>
            <RightSideBarWidth className={'hiddenMobile'}>
              <RightSidebar location={location} />
            </RightSideBarWidth>
          </div>
        </div>
      </Wrapper>
    </MDXProvider>
  </ThemeProvider>
);

export default Layout;
